import type { IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import { DefaultFetchService } from "app/services/fetchService";

import { fetchWithFullResponseConfig, fetchWithFullResponseInterceptorHandlers } from "./DefaultDataFetcher";
import { parseOrderedCompareDomainsFromKeys } from "./referralsWidgetFetcherUtils";

export type ReferralsFetchTransformContext = {
    readonly orderedCompareDomains: readonly string[];
};

export const createReferralsDataFetcherFactory = <T = any>(
    transformResponse: (response: any, context: ReferralsFetchTransformContext) => T,
): IDataFetcherFactory<T> => ({
    create(widget: IWidget<T>) {
        const fetchService = DefaultFetchService.getInstance();

        return {
            fetch: async (params: any = widget.apiParams): Promise<T> => {
                const { endpoint, ...requestParams } = params;
                const orderedCompareDomains = parseOrderedCompareDomainsFromKeys(requestParams.keys);

                const response = await fetchService
                    .get(endpoint, { ...requestParams, key: requestParams.keys }, fetchWithFullResponseConfig)
                    .then(...fetchWithFullResponseInterceptorHandlers);

                return transformResponse(response, { orderedCompareDomains });
            },
            destroy: () => undefined,
        };
    },
});
